import { ShowScanQualityIssues as ShowScanQualityIssuesComponent } from '@verifime/components';
import { TIdentityDocumentType } from '@verifime/utils';
import { hooksApi } from './api';
import { CircularProgress, Typography } from '@mui/material';

/**
 * Displays scan quality issues for a given customer and identity document type.
 *
 * This component fetches the latest scan result for the specified customer and document type,
 * and renders a loading indicator while fetching, an error message if the fetch fails,
 * or a list of failed quality checks if available.
 *
 * @param customerId - The unique identifier of the customer whose scan results are to be displayed.
 * @param type - The type of identity document being checked.
 * @returns A React element displaying loading, error, or scan quality issues.
 */
export default function ShowScanQualityIssues({
  customerId,
  type,
}: Readonly<{
  customerId: string;
  type: TIdentityDocumentType;
}>) {
  const {
    data: latestScanResult,
    isLoading,
    error,
  } = hooksApi.useGetV2personIdidentityDocumentTypescanResultlatest({
    params: {
      type,
      id: customerId,
    },
  });

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error?.message) {
    return <Typography color="error">Error loading scan results: {error.message}</Typography>;
  }

  const failedChecks = latestScanResult?.failedQualityChecks ?? [];
  return <ShowScanQualityIssuesComponent failedChecks={failedChecks} />;
}
